<!-- Custom Legend -->

<div class="relative flex w-full items-center justify-center py-12">
	<div class="absolute left-0 top-0 flex flex-col gap-2">
		@for (dataset of datasets; track dataset.label) {
			<div class="flex items-center gap-2">
				<!-- Outer circle as border -->
				<div
					class="flex h-4 w-4 items-center justify-center rounded-full"
					[style.backgroundColor]="dataset.pointBorderColor"
				>
					<!-- Inner circle as dot -->
					<div class="h-2 w-2 rounded-full" [style.backgroundColor]="dataset.pointBackgroundColor"></div>
				</div>

				<span class="text-sm text-gray-800">{{ dataset.label }}</span>
			</div>
		}
	</div>

	<!-- Radar Chart -->
	<canvas #radarChart class="mb-6 max-h-[700px] max-w-[700px]" width="700" height="700"></canvas>
</div>
